@let pro = isProfessional();
<form [formGroup]="peopleForm" class="pa" [class.pa--loading]="isLoadingData()" [attr.aria-busy]="isLoadingData()"
  (submit)="$event.preventDefault()" novalidate>

  <!-- Identity: avatar + name -->
  <div class="pa-identity">
    @if (pro) {
    <label class="pa-avatar pa-avatar--pick" [style.--pa-color]="avatarColor()"
      [attr.title]="professionalAvatarPreview() ? 'Cambiar foto' : 'Subir foto'">
      @if (professionalAvatarPreview()) {
      <img [src]="professionalAvatarPreview()!" alt="" />
      } @else {
      <span aria-hidden="true">{{ initials() }}</span>
      }
      <span class="pa-avatar__badge" aria-hidden="true">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
          <circle cx="12" cy="13" r="3" />
        </svg>
      </span>
      <input type="file" accept="image/jpeg,image/png,image/jpg,image/webp" class="pa-sr-only"
        [attr.aria-label]="professionalAvatarPreview() ? 'Cambiar foto del profesional' : 'Subir foto del profesional'"
        (change)="onProfessionalAvatarSelected($event)" />
    </label>
    } @else {
    <span class="pa-avatar" aria-hidden="true">{{ initials() }}</span>
    }

    <div class="pa-names">
      <div class="pa-field">
        <label class="pa-label" for="pa-firstName">Nombre</label>
        <input id="pa-firstName" type="text" formControlName="firstName" autocomplete="given-name" maxlength="100"
          class="pa-input" [class.pa-input--error]="showError('firstName')"
          [attr.aria-invalid]="showError('firstName')"
          [attr.aria-describedby]="showError('firstName') ? 'pa-firstName-error' : null" />
        @if (showError('firstName')) {
        <p class="pa-error" id="pa-firstName-error">{{ errorFor('firstName') }}</p>
        }
      </div>
      <div class="pa-field">
        <label class="pa-label" for="pa-lastName">Apellido</label>
        <input id="pa-lastName" type="text" formControlName="lastName" autocomplete="family-name" maxlength="100"
          class="pa-input" [class.pa-input--error]="showError('lastName')"
          [attr.aria-invalid]="showError('lastName')"
          [attr.aria-describedby]="showError('lastName') ? 'pa-lastName-error' : null" />
        @if (showError('lastName')) {
        <p class="pa-error" id="pa-lastName-error">{{ errorFor('lastName') }}</p>
        }
      </div>
    </div>
  </div>

  @if (pro) {
  <div class="pa-photo-note">
    @if (hasNewAvatar()) {
    <span>Foto nueva lista. Se guarda al confirmar.</span>
    <button type="button" class="pa-link" (click)="discardNewAvatar()">Descartar foto nueva</button>
    } @else {
    <span>Toca la foto para {{ professionalAvatarPreview() ? 'cambiarla' : 'subir una' }}. Tus clientes la ven al reservar. JPG, PNG o WebP de máximo 5 MB.</span>
    }
  </div>
  }

  <!-- Contact -->
  <div class="pa-field">
    <label class="pa-label" for="pa-phone">Celular</label>
    <app-phone-input formControlName="phone" id="pa-phone"></app-phone-input>
    @if (showError('phone')) {
    <p class="pa-error">{{ errorFor('phone') }}</p>
    } @else {
    <p class="pa-hint">Elige el país y escribe el número sin el indicativo.</p>
    }
  </div>

  <div class="pa-field">
    <label class="pa-label" for="pa-email">Correo <span class="pa-optional">(opcional)</span></label>
    <input id="pa-email" type="email" formControlName="email" autocomplete="email" inputmode="email" maxlength="255"
      placeholder="nombre@correo.com" class="pa-input" [class.pa-input--error]="showError('email')"
      [attr.aria-invalid]="showError('email')"
      [attr.aria-describedby]="showError('email') ? 'pa-email-error' : null" />
    @if (showError('email')) {
    <p class="pa-error" id="pa-email-error">{{ errorFor('email') }}</p>
    } @else if (emailWillBeKept()) {
    <p class="pa-hint pa-hint--warn">Si lo dejas vacío se conserva el correo actual ({{ savedEmail() }}).</p>
    }
  </div>

  <!-- Professional: calendar color -->
  @if (pro) {
  <fieldset class="pa-field pa-fieldset">
    <legend class="pa-label">Color en el calendario <span class="pa-optional">(opcional)</span></legend>
    <div class="pa-swatches">
      @for (hex of colorPresets; track hex) {
      <button type="button" class="pa-swatch" [style.background]="hex" [attr.aria-label]="'Usar el color ' + hex"
        [attr.aria-pressed]="peopleForm.value.color === hex" (click)="setColor(hex)">
        @if (peopleForm.value.color === hex) {
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
        }
      </button>
      }
      <label class="pa-swatch pa-swatch--custom" title="Otro color">
        <input type="color" [value]="peopleForm.value.color || '#465FFF'" (input)="onCustomColor($event)"
          aria-label="Elegir otro color" />
        <span aria-hidden="true">+</span>
      </label>
    </div>
    <p class="pa-hint">Sus citas se pintan con este color en el calendario.</p>
  </fieldset>
  }
</form>
